import React from 'react'
import Icon from 'react-icons-kit'
import { upload } from 'react-icons-kit/ionicons'
import { connect } from 'react-redux'
import { compose } from 'redux'

import Button from '../../views/buttons/Button'
import { withModal } from '../../../modules/modal/withModal'
import LinkListImageEditModal from '../link-list/LinkListImageEditModal'
import { withImageListItem } from '../image-edit/ImageItem'
import LinkListItemForm from './LinkListItemForm';

class LinkItem extends React.Component {
  render() {
    const { item, itemIndex } = this.props
    return <LinkListItemForm link={item} index={itemIndex} />
  }
}

let UploadImageButton = ({ showModal }) => (
  <Button className="is-white" onClick={showModal}>
    <Icon icon={upload} size={24} />
  </Button>
)

UploadImageButton = compose(
  connect(({ portal }) => ({
    portalId: portal._id,
  })),
  withModal(LinkListImageEditModal, {
    props: ownProps => ({
      portalId: ownProps.portalId,
      currentImageId: ownProps.item.mainImageId,
      onReloadImage: ownProps.onReloadImage,
      linkIndex: ownProps.itemIndex,
      imageAspectRatio: 16/9,
      longerWidth: 1600
    }),
  }),
)(UploadImageButton)

export default withImageListItem(LinkItem, [UploadImageButton])



// WEBPACK FOOTER //
// ./src/components/templates/link-list/LinkListItem.js